<template>
  <aside class="ModalImage" id="ModalImage" >
    <div class="overlay" @click="closeModal"></div>
    <div class="modal_wrapper" id="ModalWrapper" >
      <div class="close" @click="closeModal"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#030047"/></svg></div>
      <div class="notice_content" >
        <img :src="url" v-if="url" />
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: ['url'],
  mounted () {
    this.$nextTick(() => {
      let heightDocument = document.getElementById('ModalImage').scrollHeight
      let heightModal= document.getElementById('ModalWrapper').clientHeight
      let calcMargin = (heightDocument - heightModal) / 2
      document.getElementById('ModalWrapper').style.margin = `${calcMargin}px auto`
    })
  },
  methods: {
    closeModal () {
      this.$emit('closeModalImage')
    },
  },
}
</script>

<style lang="sass" >
@import '../assets/css/variables'

.ModalImage
  position: fixed
  left: 0
  top: 0
  width: 100%
  height: 100vh
  z-index: 20
  overflow: auto
  padding: 0 30px
  box-sizing: border-box
  .overlay
    background-color: rgba(black, .8)
    width: 100%
    height: 100%
    position: fixed
    left: 0
    top: 0
    z-index: 12
  .modal_wrapper
    background-color: white
    width: 100%
    max-width: 800px
    overflow: hidden
    z-index: 13
    position: relative
    // padding: 30px 0
    box-sizing: border-box
    margin: 50px auto
    display: flex
    flex-direction: column
    justify-content: center
    box-shadow: 0 4px 25px 2px rgba(black, .1)
    .close
      width: 40px
      height: 40px
      position: absolute
      right: 10px
      top: 10px
      display: flex
      align-items: center
      justify-content: center
      border-radius: 50%
      cursor: pointer
      background-color: transparent
      transition: background-color ease-in-out .2s
      background-color: rgba(white, 1)
      svg path
        fill: black
    .notice_content
      min-height: 500px
      font-family: $font
      // padding: 40px 50px
      box-sizing: border-box
      color: $primary_color
      display: flex
      flex-direction: column
      justify-content: center
      img
        height: 500px
        object-fit: contain
        width: 100%
        display: block
      h1
        font-size: 24px
        font-weight: 700
        margin-top: 25px
        margin-bottom: 20px
        line-height: 1.3
      p
        line-height: 1.5

</style>
